// import * as go from "gojs/release/go-module";
// import * as go from "gojs/release/go-debug-module";
const go = require("gojs");
import icons from './icons';
import shapes from './shapes';
import themes from './themes';

const $ = go.GraphObject.make;
let lookAheads = [];
let hindSights = [];

export const getDiagramLayout = function(layoutType) {
  // console.log('getDiagramLayout', layoutType);
  switch (layoutType) {
    case "treeHorizontal":
      return {
        "animationManager.isEnabled": false,
        "draggingTool.isCopyEnabled": false,
        initialDocumentSpot: go.Spot.Top,
        initialViewportSpot: go.Spot.Top,
        layout:
          $(go.TreeLayout,  // use a TreeLayout to position all of the nodes
            {
              treeStyle: go.TreeLayout.StyleLayered,
              angle: 0,
              isOngoing: false,  // don't relayout when expanding/collapsing panels
            })
      }
      case "treeVertical":
        return {
          "animationManager.isEnabled": false,
          "draggingTool.isCopyEnabled": false,
          initialDocumentSpot: go.Spot.Top,
          initialViewportSpot: go.Spot.Top,
          layout:
            $(go.TreeLayout,  // use a TreeLayout to position all of the nodes
              {
                treeStyle: go.TreeLayout.StyleLayered,
                angle: 90,
                isOngoing: false,  // don't relayout when expanding/collapsing panels
              })
        }
    case "none":
    default: 
      return {
        "animationManager.isEnabled": false,
        "draggingTool.isCopyEnabled": false,
        initialContentAlignment: go.Spot.TopLeft,
        padding: new go.Margin(20, 0, 0, 20),
        LinkDrawn: showLinkLabel,  // this DiagramEvent listener is defined below
        LinkRelinked: showLinkLabel,
        "undoManager.isEnabled": true,  // enable undo & redo
        layout: new go.Layout()
      }
  }
}

export const getTaskTemplate = (contextMenu, contextMenuAction, preventHighlight) => {
  const mt8 = new go.Margin(8, 0, 0, 0);
  const mr8 = new go.Margin(0, 8, 0, 0);
  const ml8 = new go.Margin(0, 0, 0, 8);
  const roundedRectangleParams = {
    parameter1: 2,  // set the rounded corner
    spot1: go.Spot.TopLeft, spot2: go.Spot.BottomRight  // make content go all the way to inside edges of rounded corners
  };

  const context = getContextObject(contextMenu, contextMenuAction, preventHighlight);

  return $(go.Node, "Auto",  nodeStyle(),
    {
      // locationSpot: go.Spot.Top,
      // isShadowed: true, shadowBlur: 1,
      // shadowOffset: new go.Point(0, 1),
      // shadowColor: "rgba(0, 0, 0, .14)",
      resizable: true,
      click: function(e, node) {
        const context = getContextObject(contextMenu, contextMenuAction);
        if (preventHighlight)  {
          context.contextMenu.show(node, node.diagram);
          return;
        }
        // highlight all Links and Nodes coming out of a given Node
        var diagram = node.diagram;
   
        diagram.startTransaction("highlight");
        // remove any previous highlighting
        diagram.clearHighlighteds();
        if (diagram.trail == "lookAhead") {
          // for each Link coming out of the Node, set Link.isHighlighted
          node.findLinksOutOf().each(function(l) { 
            l.isHighlighted = true; 
            l.hindSight = false;
            l.isHighlighted = true;
          });
          // for each Node destination for the Node, set Node.isHighlighted
          node.findNodesOutOf().each(function(n) { 
            n.isLookAhead = true; 
            n.hindSight = false;
            n.isHighlighted = true;
          });
        }
        if (diagram.trail == "hindSight") {
          // for each Link coming out of the Node, set Link.isHighlighted
          node.findLinksInto().each(function(l) { 
            l.isHighlighted = true; 
            l.isLookAhead = false;
            l.isHighlighted = true;
          });
          // for each Node destination for the Node, set Node.isHighlighted
          node.findNodesInto().each(function(n) { 
            n.isHindSight = true; 
            n.isLookAhead = false;
            n.isHighlighted = true;
          });
        }
      
        diagram.commitTransaction("highlight");
        
        
      },
      mouseLeave: (e, obj) => {
        // to keep transparent effect when dragging dropping task shapes from palette
        e.diagram.findLayer("Tool").opacity = 0.5
      },
      mouseDragEnter: function (e, node, prev) {
        changeZOrder(e.diagram, node);
      },
      toolTip: preventHighlight ? null : $(go.Adornment, "Auto",
        $(go.Shape, { fill: "white"}),
        $(go.TextBlock, { margin: 8 },
        
          new go.Binding("text", "",  function(data, node) {

            // so that tooltips aren't transparent
            node.diagram.findLayer("Tool").opacity = 1;

            let strText = "";
            if (data.taskRecipients == false || data.taskRecipients == true) {
              strText =  strText + `Recipients Configured: ${data.taskRecipients} `
            }
            if (data.taskConfig == false || data.taskConfig == true) {
              strText =  strText + `Task Configured: ${data.taskConfig}`
            }
            
            return strText;

          })
        )
      )
      
    },
    new go.Binding("zOrder").makeTwoWay(),
    new go.Binding("width", "width").makeTwoWay(),
    new go.Binding("height", "height").makeTwoWay(),
    $(go.Shape, "RoundedRectangle", roundedRectangleParams,

    // { name: "SHAPE", stroke: "#00a9c9", strokeWidth: 3.5 },
      { name: "SHAPE", strokeWidth: 2 },

      new go.Binding("stroke", "itaskState", function(itaskState) {
        switch (itaskState) {
          case 'inactive':
            return '#757575';
          case 'reassigned':  
          case 'initialized':  
          case 'started':
            return 'dodgerblue'; //'#e53835'; // red
          case 'timed_out':
            return 'gold'
          case 'cancelled':
            return 'gray'
          case 'failed':
            return 'red'
          case 'completed':
            return 'green';
          case "null":
          default:
            return '#00a9c9';
        }
      }),
     

      new go.Binding("fill", "", function(h, obj) {

          const diagram = h.diagram;
          if (h.isHighlighted) {
            
            if (h.isLookAhead && diagram.trail == "lookAhead") return "#b0fa8e";
            if (h.isHindSight && diagram.trail == "hindSight") return "#FBFD9B";
          }
          if (obj && obj.part && obj.part.data && obj.part.data.itaskState) {
            switch (obj.part.data.itaskState) {
                case 'inactive':
                  return '#f2f2f2';
                case 'excluded':
                    return '#f2f2f2';
                case 'reassigned':
                case 'initialized':  
                case 'started':
                    return '#ffffbd'; // red
                case 'completed':  
                    return '#f2ffe6';
                case 'timed_out':
                  return '#f2f2f2';
                case 'cancelled':
                    return '#f2f2f2';
                case 'failed':
                  return '#f2f2f2';
                case "null":
                    return themes[obj.part.data.theme].fill;
                default:
                    return themes[obj.part.data.theme].fill;
            } 
            
          } else {
                return themes[obj.part.data.theme].fill;
          }
          

        
      }).ofObject()

    ),
    $(go.Panel, "Vertical",

      $(go.Panel, "Horizontal",
        {alignment: go.Spot.Center },
        $(go.Shape, {
          margin: 3,
          strokeWidth: 0,
          scale: 1.5
          },
          new go.Binding("geometry", "taskshape", (taskshape) => { return taskShapeFunc(taskshape); }),
          new go.Binding("visible", "taskshape", function(taskshape) { return taskshape != null; }),
          new go.Binding("fill", "taskshape", (taskshape) => { return getShapeFill(taskshape); }),
          new go.Binding("fill", "", function(h, obj) {
            switch (obj.part.data.itaskState) {
                case 'inactive':
                  return '#8c8c8c';
                case 'excluded':
                    return '#8c8c8c';
                
               
              }
           
          }).ofObject(),
        ),
        $(go.Shape, {
            margin: 3,
            strokeWidth: 0,
            scale: .75,
            fill: "orange",

            
            },
            new go.Binding("geometry", "", (data, node) => { return taskConfigFunc(data,node); }),
            new go.Binding("visible", "",(data,node) => {
              return data.taskConfig == false || (data.taskRecipients == false && !data.autoComplete) || data.taskConfigValid == false;
            }),
            //new go.Binding("fill", "theme", function(theme) { return themes[theme].stroke; })

            new go.Binding("fill", "", (data, node) => {
              return data.taskConfig && !data.taskConfigValid ? "red" : "orange";
            })
        ),
      ),

         

        
      $(go.Panel, "Auto",
          {margin: 0} ,
        $(go.TextBlock, textStyle2("name"),
          {
            // row: 1, 
            textAlign: "center",
            maxSize: new go.Size(160, NaN),
            editable: true,
            wrap: go.TextBlock.WrapDesiredSize,
            
            // overflow: go.TextBlock.OverflowEllipsis,
            maxLines: 5,
            margin: new go.Margin(2, 2, 2, 2),
            stretch: go.GraphObject.Fill,
            minSize: new go.Size(85, NaN)
          },
          new go.Binding('width', '', part => part.width).ofObject(),
          new go.Binding("text", "name").makeTwoWay(),
        ),
      ),
        
      
      $(go.Shape, "LineH",
        {
          stroke: "white", strokeWidth: 1,
          height: 1, stretch: go.GraphObject.Horizontal
        },
        new go.Binding("visible").ofObject("INFO")  // only visible when info is expanded
      ),
      $(go.Panel, "Vertical",
        {
          visible: false,
          name: "INFO",  // identify to the PanelExpanderButton
          stretch: go.GraphObject.Horizontal,  // take up whole available width
          margin: 8,
          defaultAlignment: go.Spot.Left,  // thus no need to specify alignment on each element
        }
      ),
      
    ),
    context,
    // four named ports, one on each side:
    makePort("T", go.Spot.Top, go.Spot.TopSide, true, true),
    makePort("L", go.Spot.Left, go.Spot.LeftSide, true, true),
    makePort("R", go.Spot.Right, go.Spot.RightSide, true, true),
    makePort("B", go.Spot.Bottom, go.Spot.BottomSide, true, true)
  );
}

function getContextObject(contextMenu, contextMenuAction){
  const context = {}
  if (contextMenuAction == 'rightClick')
    context.contextMenu = contextMenu;
  else if (contextMenuAction == 'hover')
    context.toolTip = contextMenu;

  return context;
}

function changeZOrder(diagram, obj) {
  // When a node is dragged over another node,
  // make sure that its zOrder is incremented 1 higher than the other node
  // so that it is always on top of the other node
  if (diagram.selection && diagram.selection.first() && diagram.selection.first().data) {
    diagram.commit(function(d) {
      var targetNode = obj.part.data;
  
      d.model.set(diagram.selection.first().data, "zOrder", (targetNode.zOrder || 0) + 1);
    }, 'modified zOrder');
  }
}

export const getStartTemplate = (contextMenu, contextMenuAction) => {
  const context = getContextObject(contextMenu, contextMenuAction);

  return $(go.Node, "Table", nodeStyle(),
    {
      deletable: false
    },
    $(go.Panel, "Spot",
      $(go.Shape, "Circle",
        { desiredSize: new go.Size(70, 70),
          stroke: "#09d3ac",
          strokeWidth: 3.5 },
          new go.Binding("fill", "theme", function(theme) { return themes[theme].fill; })
        ),
      $(go.TextBlock, "Start", textStyle1(),
        new go.Binding("text"))
    ),
    context,
    // three named ports, one on each side except the top, all output only:
    makePort("T", go.Spot.Top, go.Spot.Left, true, false),
    makePort("L", go.Spot.Left, go.Spot.Left, true, false),
    makePort("R", go.Spot.Right, go.Spot.Right, true, false),
    makePort("B", go.Spot.Bottom, go.Spot.Bottom, true, false)
    )
}

export const getEndTemplate = (contextMenu, contextMenuAction) => {
  const context = getContextObject(contextMenu, contextMenuAction);

  return $(go.Node, "Table", nodeStyle(),
    {
      deletable: false
    },
    $(go.Panel, "Spot",
      $(go.Shape, "Circle", {
          desiredSize: new go.Size(60, 60),
          // stroke: "#DC3C00",
          strokeWidth: 3.5
        },
        new go.Binding("stroke", "itaskState", function(itaskState) {
          switch (itaskState) {
            case 'inactive':
              return '#757575';
            case 'completed':
            case null:
            default:
              return '#DC3C00';
          }
        }),
        new go.Binding("fill", "theme", function(theme) { return themes[theme].fill; })),
      $(go.TextBlock, "End", textStyle1(),
        new go.Binding("text"))
    ),
    context,
    // four named ports, one on each side, all input only:
    makePort("T", go.Spot.Top, go.Spot.Top, false, true),
    makePort("L", go.Spot.Left, go.Spot.Left, false, true),
    makePort("R", go.Spot.Right, go.Spot.Right, false, true),
    makePort("B", go.Spot.Bottom, go.Spot.Bottom, false, true),

    )
}
const file = function(shape, w, h) {
  var geo = new go.Geometry();
  var fig = new go.PathFigure(0, 0, true); // starting point
  geo.add(fig);
  fig.add(new go.PathSegment(go.PathSegment.Line, .75 * w, 0));
  fig.add(new go.PathSegment(go.PathSegment.Line, w, .25 * h));
  fig.add(new go.PathSegment(go.PathSegment.Line, w, h));
  fig.add(new go.PathSegment(go.PathSegment.Line, 0, h).close());
  var fig2 = new go.PathFigure(.75 * w, 0, false);
  geo.add(fig2);
  // The Fold
  fig2.add(new go.PathSegment(go.PathSegment.Line, .75 * w, .25 * h));
  fig2.add(new go.PathSegment(go.PathSegment.Line, w, .25 * h));
  geo.spot1 = new go.Spot(0, .25);
  geo.spot2 = go.Spot.BottomRight;
  return geo;
}
// taken from ../extensions/Figures.js:
go.Shape.defineFigureGenerator("File", file);

export const getCommentTemplate = (contextMenu, contextMenuAction) => {
  const context = getContextObject(contextMenu, contextMenuAction);
  return $(go.Node, "Auto", nodeStyle(), {
      resizable: true,
    },
    $(go.Shape, "File", {
          stroke: "#DEE0A3",
          strokeWidth: 3
      },
      new go.Binding("fill", "theme", function(theme) { return themes[theme].fill; })
    ),
    $(go.TextBlock, textStyle1(),
      {
        maxSize: new go.Size(NaN, NaN),

        textAlign: "center",
        editable: true,
        wrap: go.TextBlock.WrapDesiredSize,
        
        // overflow: go.TextBlock.OverflowEllipsis,
        maxLines: Infinity,
        margin: new go.Margin(2, 2, 2, 2),
        stretch: go.GraphObject.Fill,
        minSize: new go.Size(85, NaN)
      },
      new go.Binding("text").makeTwoWay()),
    // no ports, because no links are allowed to connect with a comment
      new go.Binding('visible', 'visible'),
      new go.Binding("width", "width").makeTwoWay(),
      new go.Binding("height", "height").makeTwoWay(),
      context
    )
    
}

export const getPaletteTaskType = () => {
  return $(go.Node, "Table", 
    {
      defaultAlignment: go.Spot.Left,
      selectionAdorned: false,
    },
    $(go.Panel, "Auto",
      $(go.Panel, "Horizontal",
        {
          alignment: go.Spot.Left,
          background: 'white',
          mouseEnter: function (e, obj) {
            obj.background = 'lightgray';
          },
          mouseLeave: function (e, obj) {
            obj.background = 'white';
          }
        },
        $(go.Shape, {
          margin: 8,
          strokeWidth: 0,
          width: 22,
          },
          new go.Binding("geometry", "taskshape", (taskshape) => { return taskShapeFunc(taskshape); }),
          new go.Binding("visible", "taskshape", function(taskshape) { return taskshape != null; }),
          new go.Binding("fill", "taskshape", (taskshape) => { return getShapeFill(taskshape); })
        ),
        $(go.TextBlock, 
          {
            font: "13pt Roboto, sans-serif",
            margin: 5,
            // maxSize: new go.Size(160, NaN),
            // wrap: go.TextBlock.WrapFit,
            editable: false,
            width: 165,
            
          },
          new go.Binding("text", "taskName"),
          new go.Binding("stroke", "theme", function(theme) { return themes[theme].stroke; })
        ),
        new go.Binding("pickable", "disabled", function(disabled) { return !disabled; }),
        new go.Binding("opacity", "disabled", function(disabled) { return disabled ? 0.5 : 1; })
      )
    )
  )
}

// Splice a node into a link.
// If the new node is of category "For" or "While" or "If", create a Group and splice it in,
// and add the new node to that group, and add any other desired nodes and links to that group.
export const dropOntoLink = (e, oldlink) => {
  if (!(oldlink instanceof go.Link)) return;
  var diagram = e.diagram;
  var newnode = diagram.selection.first();
  if (!(newnode instanceof go.Node)) return;
  if (!newnode.isTopLevel) return;
  if (isLoopBack(oldlink)) {
    // can't add nodes into links going back to the "For" node
    diagram.remove(newnode);
    return;
  }

  var fromnode = oldlink.fromNode;
  var tonode = oldlink.toNode;
  if (newnode.category === "") {
    // add simple step into chain of actions
    newnode.containingGroup = oldlink.containingGroup;
    // Reconnect the existing link to the new node
    oldlink.toNode = newnode;
    // Then add links from the new node to the old node

    diagram.model.addLinkData({ from: newnode.key, to: tonode.key, new: true, droppedOntoLink: true }); // only one called
  } 
  diagram.layoutDiagram(true);
}

// A node dropped onto a Merge node is spliced into a link coming into that node;
// otherwise it is spliced into a link that is coming out of that node.
function dropOntoNode(e, oldnode) {
  if (oldnode instanceof go.Node) {
    // remember the node that was dropped onto
    // and reference it in the ExternalObjectsDropped event handler
    // so we can link to it and use its coordinates as a frame of reference
    // to move the new node into position
    e.diagram.droppedOnNode = oldnode; 
  }
}

function isLoopBack(link) {
  if (!link) return false;
  if (link.fromNode.containingGroup !== link.toNode.containingGroup)
    return false;
  var cat = link.fromNode.category;
  return cat === "EndFor" || cat === "EndWhile" || cat === "EndIf";
}

function taskShapeFunc(shape) { 
  var geo = shapes[shape].shape;
  if (geo === undefined) {
    geo = shapes["unknown"].shape;
    shape = "unknown"  // use this for an unknown icon name
  }
  if (typeof geo === "string") {
    geo = shapes[shape].shape = go.Geometry.parse(geo, true);  // fill each geometry
  }
  if (shapes[shape].scalex || shapes[shape].scaley) {
    geo.scale(shapes[shape].scale ?? 1, shapes[shape].scaley ?? 1);
  }
  return geo;
}

function getShapeFill(shape, theme) {
   
  let fillColor = shapes[shape].fill;
  if (!fillColor) fillColor = "orange";
    
  return fillColor;
}

// A data binding conversion function. Given an icon name, return a Geometry.
// This assumes that all icons want to be filled.
// This caches the Geometry, because the Geometry may be shared by multiple Shapes.
function taskConfigFunc(taskConfig) {
  const icon = taskConfig === true ? 'configured' : 'notConfigured2';

  var geo = icons[icon];
  if (geo === undefined) geo = icons["configured"];  // use this for an unknown icon name
  if (typeof geo === "string") {
    geo = icons[icon] = go.Geometry.parse(geo, true);  // fill each geometry
  }

  return geo;
}
function taskRecipientsFunc(taskRecipients) {
  const icon = taskRecipients === true ? 'recipients' : 'noRecipients';

  var geo = icons[icon];
  if (geo === undefined) geo = icons["recipients"];  // use this for an unknown icon name
  if (typeof geo === "string") {
    geo = icons[icon] = go.Geometry.parse(geo, true);  // fill each geometry
  }
  return geo;
}

// Define a function for creating a "port" that is normally transparent.
// The "name" is used as the GraphObject.portId,
// the "align" is used to determine where to position the port relative to the body of the node,
// the "spot" is used to control how links connect with the port and whether the port
// stretches along the side of the node,
// and the boolean "output" and "input" arguments control whether the user can draw links from or to the port.
function makePort(name, align, spot, output, input) {
  var horizontal = align.equals(go.Spot.Top) || align.equals(go.Spot.Bottom);
  // the port is basically just a transparent rectangle that stretches along the side of the node,
  // and becomes colored when the mouse passes over it
  return $(go.Shape,
    {
      fill: "transparent",  // changed to a color in the mouseEnter event handler
      strokeWidth: 0,  // no stroke
      width: horizontal ? NaN : 8,  // if not stretching horizontally, just 8 wide
      height: !horizontal ? NaN : 8,  // if not stretching vertically, just 8 tall
      alignment: align,  // align the port on the main Shape
      stretch: (horizontal ? go.GraphObject.Horizontal : go.GraphObject.Vertical),
      portId: name,  // declare this object to be a "port"
      fromSpot: spot,  // declare where links may connect at this port
      fromLinkable: output,  // declare whether the user may draw links from here
      toSpot: spot,  // declare where links may connect at this port
      toLinkable: input,  // declare whether the user may draw links to here
      cursor: "pointer",  // show a different cursor to indicate potential link point
      mouseEnter: function(e, port) {  // the PORT argument will be this Shape
        if (!e.diagram.isReadOnly && !e.diagram.model.isReadOnly) port.fill = "rgba(255,0,255,0.5)";
      },
      mouseLeave: function(e, port) {
        port.fill = "transparent";
      }
    });
}

function nodeStyle(){
  return [
    // The Node.location comes from the "loc" property of the node data,
    // converted by the Point.parse static method.
    // If the Node.location is changed, it updates the "loc" property of the node data,
    // converting back using the Point.stringify static method.
    new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
    {
      // deletable: false,
      locationSpot: go.Spot.Center,
      mouseDragEnter: (e, node) => {
        var sh = node.findObject("SHAPE");
        if (sh) sh.fill = "#A7C7E7";
      },
      mouseDragLeave: (e, node) => {
        var sh = node.findObject("SHAPE");
        if (sh) sh.fill = "white";
      },
      mouseDrop: dropOntoNode,
    }
  ];
}

// Make link labels visible if coming out of a "conditional" node.
// This listener is called by the "LinkDrawn" and "LinkRelinked" DiagramEvents.
function showLinkLabel(e) {
  var label = e.subject.findObject("LABEL");
  if (label !== null) label.visible = (e.subject.fromNode.data.category === "Conditional");
}

function textStyle1() {
  return [
    {
      font: "bold 11pt Roboto, sans-serif"
    },
    new go.Binding("stroke", "theme", function(theme) { return themes[theme].stroke; })
  ]
}

function textStyle2(field) {
  return [
    {
      font: "bold 12px Roboto, sans-serif",
      // stroke: themes[theme].stroke,
      visible: false  // only show textblocks when there is corresponding data for them
    },
    new go.Binding("visible", field, function(val) { return val !== undefined; }),
    new go.Binding("stroke", "theme", function(theme) { return themes[theme].stroke; })
  ];
}